import Axios from "axios";
import  config  from "../../config";
const apiurl = config.ADMIN_BASE_URL;

// --------------------------------------fetchAll Special Images--------------------------------------
export const fetchAllSpecialImages = async () => {
    const token = localStorage.getItem("cookies");
    try {
        const response = await Axios.get(`${apiurl}/special-images`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching special images:", error);
        throw error;
    }
}

// --------------------------------------addSpecialImage--------------------------------------
export const addSpecialImage = async (data) => {
    console.log("data", data);
    const token = localStorage.getItem("cookies");
    try {
        const response = await Axios.post(`${apiurl}/special-images/store`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error adding special image:", error);
        throw error;
    }
}

// --------------------------------------deleteSpecialImage--------------------------------------
export const deleteSpecialImage = async (id) => {
    const token = localStorage.getItem("cookies");
    try {
        const response = await Axios.delete(`${apiurl}/special-images/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting special image:", error);
        throw error;
    }
}

// --------------------------------------updateSpecialImage--------------------------------------
export const updateSpecialImage = async (id, data) => {
    const token = localStorage.getItem("cookies");
    try {
        const response = await Axios.post(`${apiurl}/special-images/update/${id}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating special image:", error);
        throw error;
    }
}

// --------------------------------------fetchSpecialImageById--------------------------------------
export const fetchSpecialImageById = async (id) => {
    const token = localStorage.getItem("cookies");
    try {
        const response = await Axios.get(`${apiurl}/special-images/edit/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching special image by ID:", error);
        throw error;
    }
}

